module.exports = {"title":"{name}, you’re one click away from securing your voucher!"}